map_intro_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large grey-bg');

        //$('p a[data-open-modal]').click(function(e){
        //  //
        //  var _target = $(this).data().openModal;
        //  console.log(_target);
        //  $(_target).modal({
        //    clickClose: false
        //  });
        //  e.preventDefault();
        //  return false;

        //});


    },


    events: function() {
        var self = this;
        self.onLoad();

    }
}
